import { render, staticRenderFns } from "./MultipleLiveVideo.vue?vue&type=template&id=3cf82eff&scoped=true&"
import script from "./MultipleLiveVideo.vue?vue&type=script&lang=js&"
export * from "./MultipleLiveVideo.vue?vue&type=script&lang=js&"
import style0 from "./MultipleLiveVideo.vue?vue&type=style&index=0&id=3cf82eff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf82eff",
  null
  
)

export default component.exports